import PageHero from "../components/PageHero";
import FinalCTA from "../components/sections/FinalCTA";

const CONTENT = [
  ["Introduction", "Emilio's Solutions (UEN 53467871L) respects your privacy. This policy explains what information we collect through our website, how it is used and your choices."],
  ["Information We Collect", "We may collect information you voluntarily provide through WhatsApp enquiries, phone calls or email — including your name, contact details and property details relevant to a quotation."],
  ["How We Use Your Information", "To respond to enquiries, prepare quotations, deliver services and communicate about your booking."],
  ["Third-Party Services", "We may use standard analytics tools to understand website usage. These tools do not receive personally identifying information."],
  ["Data Retention", "Enquiry and booking information is retained only as long as necessary to deliver our services."],
  ["Your Choices", "You may request access, correction or deletion of your personal data by contacting us."],
  ["Contact", "For any privacy questions, contact emiliosolutions@gmail.com."],
];

export default function Privacy() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        headline={"Privacy Policy."}
        image="/generated/hero_about.png"
        imageAlt=""
        compact
        showQuoteForm={false}
      />
      <section className="bg-ink py-20 md:py-28">
        <div className="container-emilio max-w-3xl">
          <div className="space-y-10">
            {CONTENT.map(([title, body], i) => (
              <div key={i}>
                <div className="text-emerald font-mono text-xs mb-2">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h2 className="font-display font-bold text-white text-2xl md:text-3xl">
                  {title}
                </h2>
                <p className="mt-3 text-mutedtext leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
